<mat-card>
    <mat-card-title>Novo Vinho</mat-card-title>
    <form>
        <mat-form-field>
            <input matInput placeholder="Nome *" [(ngModel)]="wine.name" name="name">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="Produtor *" [(ngModel)]="wine.producer" name="producer">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="País *" [(ngModel)]="wine.country" name="country">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="Tipo de Vinho *" [(ngModel)]="wine.type" name="type">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="Tipo de uva *" [(ngModel)]="wine.type_grape" name="type_grape">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="Harmonização" [(ngModel)]="wine.harmonizing" name="harmonizing">
        </mat-form-field>

        <label>Inserir imagem do produto (OBS: apenas imagem menores que 1MB serão aceitas)</label><br>
        <label for='selecao-arquivo' class="label-input-file">Selecionar uma imagem &#187;</label>
        <input id='selecao-arquivo' type='file' accept="image/*" (change)="uploadFileEvt($event)"><br>
        <img *ngIf="imgBase64Path" [src]="imgBase64Path">
    </form>

    <div align="end">
        <button mat-raised-button (click)="createWine()" [disabled]="!validaForm()" color="primary">
            Salvar
        </button>

        <button mat-raised-button (click)="cancel()">
            Cancelar
        </button>
    </div>
</mat-card>